const blogs = [
    {
      title: 'Check at least a doctor in a year for your teeth',
      description:
        'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ea, placeat totam laborum maiores, esse assumenda porro error natus sit ipsam.        ',
      author: 'Dr. Cudi',
      authorImg: 'https://i.ibb.co/XL2y02K/wKeBuuY.png',
      date: '23 April 2019',
    },
    {
      title: 'Two time brush in a day can keep you healthy',
      description:
        'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ea, placeat totam laborum maiores, esse assumenda porro error natus sit ipsam.        ',
      author: 'Dr. Sinthia',
      authorImg: 'https://i.ibb.co/FXNQC2Z/egLZkQ0.png',
      date: '23 April 2019',
    },
    {
      title: 'The tooth cancer is taking a challenge',
      description:
        'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ea, placeat totam laborum maiores, esse assumenda porro error natus sit ipsam.        ',
      author: 'Dr. Cudi',
      authorImg: 'https://i.ibb.co/612jf5D/dmNBC61.png',
      date: '23 April 2019',
    },
  ];
  
  export default blogs;
  